import React, { useEffect, useState } from "react";
import "./registration.scss";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router";
import Dialog from "@mui/material/Dialog";
import picGuildLines from "../../assets/photoGuildLines.png";
import {
  complexionValues,
  maritial_statusValues,
  rashiValues,
  nakshatraValues,
  charanValues,
  nadiValues,
  ganValues,
  mangalValues,
  API_URL,
  siblingsCount,
} from "../../variables";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

const Registration = () => {
  const [userInfo, setUserInfo] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    gender: "Male",
    heightFt: "",
    heightInch: "",
    blood_group: "",
    spectacles: "No",
    weight: "",
    maritial_status: "unmarried",
    diet: "Both",
    physical_disability: "No",
    complexion: "",
    mother_tongue: "Marathi",
    rashi: "",
    nakshatra: "",
    charan: "",
    nadi: "",
    gan: "",
    mangal: "",
    dob: "",
    birthplace: "",
    birth_time: "",
    education_area: "",
    education: "",
    occupation: "",
    income: "",
    income_amt: "",
    income_type: "",
    country: "",
    state: "",
    city: "",
    adhar: "",
    mobile_no: "",
    sec_mobile: "",
    address: "",
    email: "",
    father: "yes",
    mother: "yes",
    brother: "0",
    married_brother: "0",
    sister: "0",
    married_sister: "0",
    parents_full_name: "",
    parents_occupation: "",
    parents_resident_city: "",
    relative_surnames: "",
    mama_surname: "",
    native_district: "",
    native_taluka: "",
    intercast_marriage: "No",
    caste: "",
    preffered_cities: "",
    exp_mangal: "",
    exp_heightFt: "",
    exp_heightInch: "",
    exp_diet: "Both",
    exp_education: "",
    exp_maritial_status: "",
    exp_age_diff: "",
    exp_occupation_income: "",
    committee_member: "",
    // ksj_family_id: "",
    acknowledgement: "No",
    //status: "deactive",
    // image1_id: {},
    // image2_id: {},
  });
  const validateEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [submitBtnClicked, setSubmitBtnClicked] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [committeeMembers, setCommitteeMembers] = useState([]);
  var specialCharecters = /[`!@#$%^&*()_+\-=\[\]{};':"\\|<>\/?~]/;
  var addressCheck = /[`!@#$%^&*+=\[\]{};"\\|<>?~]/;
  useEffect(() => {
    window.scrollTo(0, 0);
    getCommitteeMembersInfo();
  }, []);
  let navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const getCommitteeMembersInfo = async () => {
    let res = await axios.get(API_URL + "committee_members");
    if (res?.data?.body?.length > 0) {
      let arr = [];
      for (let i = 0; i < res.data.body.length; i++) {
        let name_and_mobile =
          res.data.body[i].name + ", " + res.data.body[i].mobile;
        arr.push(name_and_mobile);
      }
      setCommitteeMembers(arr);
    }
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const submitUserDetails = async (e) => {
    if (
      !(
        userInfo.first_name === "" ||
        userInfo.middle_name === "" ||
        userInfo.last_name === "" ||
        userInfo.dob === "" ||
        userInfo.birth_time === "" ||
        userInfo.mobile_no === "" ||
        userInfo.committee_member === "" ||
        userInfo.email === "" ||
        userInfo.adhar === "" 
        //userInfo.ksj_family_id === ""
      )
    ) {
      const response = await axios.post(
        API_URL + "addmember?data=" + JSON.stringify(userInfo)
      );
      if (response.data.statusCode === 200) {
        toast.success(response.data.body, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        //navigate('/login');
      }
      if (response.data.statusCode === 400) {
        toast.error(response.data.body, {
          position: "top-center",
          autoClose: 8000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <section className="p-2 formSection bg-white mt-4">
        <label className="headerLabel">ENROLLMENT FORM</label>
        {/* <form onSubmit={handleSubmit}> */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">
              PERSONAL DETAILS / वैयक्तिक माहिती :
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    First Name / पहिले नाव *
                  </label>
                  <TextField
                    error={submitBtnClicked && userInfo.first_name === ""}
                    size="small"
                    variant="outlined"
                    placeholder="First Name / पहिले नाव"
                    value={userInfo.first_name}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          first_name: event.target.value,
                        }));
                      }
                    }}
                  />
                  {submitBtnClicked && userInfo.first_name === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Middle Name / मधले नाव *
                  </label>
                  <TextField
                    error={submitBtnClicked && userInfo.middle_name === ""}
                    size="small"
                    variant="outlined"
                    placeholder="Middle Name / मधले नाव"
                    value={userInfo.middle_name}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          middle_name: event.target.value,
                        }));
                      }
                    }}
                  />
                  {submitBtnClicked && userInfo.middle_name === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Last Name / आडनाव *</label>
                  <TextField
                    error={submitBtnClicked && userInfo.last_name === ""}
                    size="small"
                    variant="outlined"
                    placeholder="Last Name / आडनाव"
                    value={userInfo.last_name}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          last_name: event.target.value,
                        }));
                      }
                    }}
                  />
                  {submitBtnClicked && userInfo.last_name === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Height / उंची (ft : inch)
                  </label>
                  <div className="d-flex heightDropdowns">
                    <Select
                      placeholder="Feet"
                      className="w-50 d-inline-block mr-1"
                      value={userInfo.heightFt}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          heightFt: event.target.value,
                        }));
                      }}
                    >
                      <MenuItem value="">Feet</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7</MenuItem>
                      <MenuItem value="8">8</MenuItem>
                    </Select>
                    <Select
                      className="w-50 d-inline-block ml-1"
                      value={userInfo.heightInch}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          heightInch: event.target.value,
                        }));
                      }}
                    >
                      <MenuItem value="">Inches</MenuItem>
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7</MenuItem>
                      <MenuItem value="8">8</MenuItem>
                      <MenuItem value="9">9</MenuItem>
                      <MenuItem value="10">10</MenuItem>
                      <MenuItem value="11">11</MenuItem>
                      <MenuItem value="12">12</MenuItem>
                    </Select>
                  </div>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Blood Group / रक्त गट
                  </label>
                  <Select
                    value={userInfo.blood_group}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        blood_group: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="A+">A+</MenuItem>
                    <MenuItem value="A-">A-</MenuItem>
                    <MenuItem value="B+">B+</MenuItem>
                    <MenuItem value="B-">B-</MenuItem>
                    <MenuItem value="AB+">AB+</MenuItem>
                    <MenuItem value="AB-">AB-</MenuItem>
                    <MenuItem value="O+">O+</MenuItem>
                    <MenuItem value="O-">O-</MenuItem>
                    <MenuItem value="--">Don't Know</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <label className="inputFieldLabel d-block">
                  Spectacles / चष्मा
                </label>
                <FormControl>
                  <RadioGroup
                    name="Spectacles"
                    row
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        spectacles: event.target.value,
                      }));
                    }}
                    value={userInfo.spectacles}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Weight / वजन(KG)</label>
                  <TextField
                    type="number"
                    size="small"
                    variant="outlined"
                    placeholder="Weight in KG"
                    value={userInfo.weight}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        weight: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Maritial Status / वैवाहिक स्थिती
                  </label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.maritial_status}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        maritial_status: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {maritial_statusValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <label className="inputFieldLabel w-100">Diet / आहार</label>
                <FormControl>
                  <RadioGroup
                    name="Diet"
                    row
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        diet: event.target.value,
                      }));
                    }}
                    value={userInfo.diet}
                  >
                    <FormControlLabel
                      value="Veg"
                      control={<Radio />}
                      label="Veg"
                    />
                    <FormControlLabel
                      value="Non Veg"
                      control={<Radio />}
                      label="Non Veg"
                    />
                    <FormControlLabel
                      value="Both"
                      control={<Radio />}
                      label="Both"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <label className="inputFieldLabel d-block">Gender / लिंग</label>
                <FormControl>
                  <RadioGroup
                    name="Gender"
                    row
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        gender: event.target.value,
                      }));
                    }}
                    value={userInfo.gender}
                  >
                    <FormControlLabel
                      value="Male"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="Female"
                      control={<Radio />}
                      label="Female"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <label className="inputFieldLabel w-100">
                  Physical disability / शारीरिक अपंगत्व
                </label>
                <FormControl>
                  <RadioGroup
                    name="Disability"
                    row
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        physical_disability: event.target.value,
                      }));
                    }}
                    value={userInfo.physical_disability}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Complexion / रंग </label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.complexion}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        complexion: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {complexionValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Mother Tongue / मातृभाषा
                  </label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.mother_tongue}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        mother_tongue: event.target.value,
                      }));
                    }}
                  >
                    <span className="pl-3 font-bold">Official Languages</span>
                    <MenuItem className="text-capitalize" value={"hindi"}>
                      Hindi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"english"}>
                      English
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"other"}>
                      Other
                    </MenuItem>
                    <span className="pl-3 font-bold">Major Languages</span>
                    <MenuItem className="text-capitalize" value={"bengali"}>
                      Bengali
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"telugu"}>
                      Telugu
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"marathi"}>
                      Marathi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"tamil"}>
                      Tamil
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"gujarati"}>
                      Gujarati
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"malayalam"}>
                      Malayalam
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"kannada"}>
                      Kannada
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"odia"}>
                      Odia
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"punjabi"}>
                      Punjabi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"assamese"}>
                      Assamese
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"maithili"}>
                      Maithili
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"santhali"}>
                      Santhali
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"kashmiri"}>
                      Kashmiri
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"nepali"}>
                      Nepali
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"konkani"}>
                      Konkani
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"manipuri"}>
                      Manipuri
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"dogri"}>
                      Dogri
                    </MenuItem>
                    <span className="pl-3 font-bold">
                      Regional Languages and Dialects
                    </span>
                    <MenuItem className="text-capitalize" value={"bodo"}>
                      Bodo
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"khasi"}>
                      Khasi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"sindhi"}>
                      Sindhi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"urdu"}>
                      Urdu
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"rajasthani"}>
                      Rajasthani
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"magahi"}>
                      Magahi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"bhojpuri"}>
                      Bhojpuri
                    </MenuItem>
                    <MenuItem
                      className="text-capitalize"
                      value={"chhattisgarhi"}
                    >
                      Chhattisgarhi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"haryanvi"}>
                      Haryanvi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"awadhi"}>
                      Awadhi
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"garhwali"}>
                      Garhwali
                    </MenuItem>
                    <MenuItem className="text-capitalize" value={"himachali"}>
                      Himachali
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">
              HOROSCOPE DETAILS / कुंडली तपशील :
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Rashi / राशी</label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.rashi}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        rashi: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {rashiValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Nakshatra / नक्षत्र</label>
                  <Select
                    value={userInfo.nakshatra}
                    className="text-capitalize"
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        nakshatra: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {nakshatraValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Charan / चरण</label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.charan}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        charan: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {charanValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Nadi / नाडी</label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.nadi}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        nadi: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {nadiValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Gan / गण</label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.gan}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        gan: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {ganValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Mangal / मंगल</label>
                  <Select
                    className="text-capitalize"
                    value={userInfo.mangal}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        mangal: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {mangalValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl
                  variant="outlined"
                  className="w-100 datePicker"
                  size="small"
                >
                  <label className="inputFieldLabel">
                    Date of birth / जन्मतारीख *
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        className={
                          submitBtnClicked && userInfo.dob === "" ? "error" : ""
                        }
                        onChange={(event) => {
                          var date = new Date(event.$d),
                            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                            day = ("0" + date.getDate()).slice(-2);
                          let dateOfBirth = [
                            day,
                            mnth,
                            date.getFullYear(),
                          ].join("-");
                          setUserInfo((prev) => ({
                            ...prev,
                            dob: dateOfBirth,
                          }));
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  {submitBtnClicked && userInfo.dob === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel mb-2">
                    Birthplace / जन्मस्थान
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Birthplace / जन्मस्थान"
                    value={userInfo.birthplace}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        birthplace: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl
                  variant="outlined"
                  className="w-100 datePicker"
                  size="small"
                >
                  <label className="inputFieldLabel">
                    Birth Time / जन्मवेळ *
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        className={
                          submitBtnClicked && userInfo.birth_time === ""
                            ? "error"
                            : ""
                        }
                        onChange={(event) => {
                          let time = event.$H + ":" + event.$m;
                          setUserInfo((prev) => ({
                            ...prev,
                            birth_time: time,
                          }));
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  {submitBtnClicked && userInfo.birth_time === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">
              Educational / Professional Details / शैक्षणिक / व्यावसायिक तपशील :
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Education Area / शिक्षण क्षेत्र
                  </label>
                  <Select
                    value={userInfo.education_area}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        education_area: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="12th">10th</MenuItem>
                    <MenuItem value="12th">12th</MenuItem>
                    <MenuItem value="diploma">Diploma</MenuItem>
                    <MenuItem value="graduate">Graduate</MenuItem>
                    <MenuItem value="post graduate">Post - Graduate</MenuItem>
                    <MenuItem value="doctor">Doctor</MenuItem>
                    <MenuItem value="engineer">Engineer / PG Engg</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Education / शिक्षण</label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Education"
                    value={userInfo.education}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        education: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Occupation / व्यवसाय
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Occupation"
                    value={userInfo.occupation}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        occupation: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Income / उत्पन्न</label>
                  <div>
                    <TextField
                      type="number"
                      className="w-50 d-inline-block"
                      size="small"
                      variant="outlined"
                      placeholder="Enter Income"
                      value={userInfo.income_amt}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          income_amt: event.target.value,
                          income:
                            event.target.value.length > 0
                              ? event.target.value + " " + userInfo.income_type
                              : "",
                        }));
                      }}
                    />
                    <Select
                      className="w-25 d-inline-block ml-2 bg-white p-1"
                      value={userInfo.income_type}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          income_type: event.target.value,
                          income:
                            userInfo.income_amt.length > 0
                              ? userInfo.income_amt + " " + event.target.value
                              : "",
                        }));
                      }}
                    >
                      <MenuItem value="pm">PM</MenuItem>
                      <MenuItem value="pa">PA</MenuItem>
                    </Select>
                  </div>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Country / व्यवसाय देश
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Country"
                    value={userInfo.country}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          country: event.target.value,
                        }));
                      }
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">State / राज्य</label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter State"
                    value={userInfo.state}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          state: event.target.value,
                        }));
                      }
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">City / शहर</label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter City"
                    value={userInfo.city}
                    onChange={(event) => {
                      if (!specialCharecters.test(event.target.value)) {
                        setUserInfo((prev) => ({
                          ...prev,
                          city: event.target.value,
                        }));
                      }
                    }}
                  />
                </FormControl>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">Address / पत्ता :</Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Aadhar Number *</label>
                  <TextField
                    className="w-100"
                    error={submitBtnClicked && userInfo.adhar === ""}
                    placeholder="Enter PAN / Adhar / Driving License / Passport No"
                    size="small"
                    variant="outlined"
                    value={userInfo.adhar}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        adhar: event.target.value,
                      }));
                    }}
                  />
                  {submitBtnClicked && userInfo.adhar === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Primary contact number / प्राथमिक संपर्क क्रमांक *
                  </label>
                  <TextField
                    type="number"
                    className="w-100"
                    error={submitBtnClicked && userInfo.mobile_no === ""}
                    placeholder="Enter  Primary contact number"
                    size="small"
                    variant="outlined"
                    value={userInfo.mobile_no}
                    onChange={(event) => {
                      if (event.target.value.length < 11)
                        setUserInfo((prev) => ({
                          ...prev,
                          mobile_no: event.target.value,
                        }));
                    }}
                  />
                  {submitBtnClicked && userInfo.mobile_no === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Secondary contact number / दुय्यम संपर्क क्रमांक
                  </label>
                  <TextField
                    type="number"
                    className="w-100"
                    placeholder="Enter Secondary contact number"
                    size="small"
                    variant="outlined"
                    value={userInfo.sec_mobile}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        sec_mobile: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-8">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Residence Address / निवासाचा पत्ता
                  </label>
                  <TextField
                    className="w-100"
                    placeholder="Enter Residence Address"
                    size="small"
                    variant="outlined"
                    value={userInfo.address}
                    onChange={(event) => {
                      if (!addressCheck.test(event.target.value))
                        setUserInfo((prev) => ({
                          ...prev,
                          address: event.target.value,
                        }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    E-mail ID (Its important) / ई-मेल आयडी (त्याचा महत्त्वाचा) *
                  </label>
                  <TextField
                    className="w-100"
                    placeholder="Enter email address"
                    size="small"
                    variant="outlined"
                    value={userInfo.email}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        email: event.target.value,
                      }));
                      if (!validateEmail.test(event.target.value)) {
                        setEmailError(true);
                      }
                    }}
                  />
                  {submitBtnClicked && userInfo.email === "" && (
                    <span className="requiredText">Required</span>
                  )}
                  {emailError && (
                    <span className="font12px">
                      Please type correct email e.g, xxxxxxx@gmail.com
                    </span>
                  )}
                </FormControl>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">
              Family Background / कौटुंबिक पार्श्वभूमी :
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Father / वडील</label>
                  <Select
                    value={userInfo.father}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        father: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value={"yes"}>Yes</MenuItem>
                    <MenuItem value={"no"}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Mother / आई</label>
                  <Select
                    value={userInfo.mother}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        mother: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value={"yes"}>Yes</MenuItem>
                    <MenuItem value={"no"}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Brothers</label>
                  <Select
                    value={userInfo.brother}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        brother: event.target.value,
                      }));
                    }}
                  >
                    {siblingsCount?.map((item, index) => {
                      return (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Married Brothers / विवाहित भाऊ{" "}
                  </label>
                  <Select
                    value={userInfo.married_brother}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        married_brother: event.target.value,
                      }));
                    }}
                  >
                    {siblingsCount?.map((item, index) => {
                      return (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Sisters</label>
                  <Select
                    value={userInfo.sister}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        sister: event.target.value,
                      }));
                    }}
                  >
                    {siblingsCount?.map((item, index) => {
                      return (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Married Sisters / विवाहित बहिणी{" "}
                  </label>
                  <Select
                    value={userInfo.married_sister}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        married_sister: event.target.value,
                      }));
                    }}
                  >
                    {siblingsCount?.map((item, index) => {
                      return (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Parents Fullname / पालकांचे पूर्ण नाव
                  </label>
                  <TextField
                    placeholder="Enter parents full name"
                    size="small"
                    variant="outlined"
                    value={userInfo.parents_full_name}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        parents_full_name: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Parents Occupation / पालकांचा व्यवसाय
                  </label>
                  <TextField
                    placeholder="Enter parents occupation"
                    size="small"
                    variant="outlined"
                    value={userInfo.parents_occupation}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        parents_occupation: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Parents Resident City / पालक निवासी शहर
                  </label>
                  <TextField
                    placeholder="Enter parents resident city"
                    size="small"
                    variant="outlined"
                    value={userInfo.parents_resident_city}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        parents_resident_city: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Surnames of Relatives / नातेवाईकांची आडनावे
                  </label>
                  <textarea
                    placeholder="Enter surnames"
                    className="p-2"
                    rows="5"
                    value={userInfo.relative_surnames}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        relative_surnames: event.target.value,
                      }));
                    }}
                  ></textarea>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Mama’s Surname / Place / आईचे आडनाव / ठिकाण
                  </label>
                  <textarea
                    placeholder="Enter surname/place"
                    className="p-2"
                    rows="5"
                    value={userInfo.mama_surname}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        mama_surname: event.target.value,
                      }));
                    }}
                  ></textarea>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="standard" className="w-100 mb-3">
                  <label className="inputFieldLabel">
                    Native District / मूळ जिल्हा
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Native District"
                    value={userInfo.native_district}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        native_district: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">
                    Native Taluka, if any / मूळ तालुका, असल्यास :
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter Native Taluka"
                    value={userInfo.native_taluka}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        native_taluka: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Any Intercast Marriage in Core Family / मूळ कुटुंबात कोणताही
                    आंतरजातीय विवाह
                  </label>
                  <Select
                    value={userInfo.intercast_marriage}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        intercast_marriage: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value={"yes"}>Yes</MenuItem>
                    <MenuItem value={"no"}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    If yes (Relation/Caste) / जर होय (नाते/जात):
                  </label>
                  <TextField
                    size="small"
                    variant="outlined"
                    value={userInfo.caste}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        caste: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">
              Expectation / अपेक्षा
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails">
            <div className="row">
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Preferred Cities / पसंतीची शहरे
                  </label>
                  <TextField
                    placeholder="Enter preferred cities"
                    size="small"
                    variant="outlined"
                    value={userInfo.preffered_cities}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        preffered_cities: event.target.value,
                      }));
                    }}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">Mangal / मंगल</label>
                  <Select
                    value={userInfo.exp_mangal}
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_mangal: event.target.value,
                      }));
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                    <MenuItem value="saumya">Saumya</MenuItem>
                    <MenuItem value="nirdosh">Nirdosh</MenuItem>
                    <MenuItem value="not known">Not Known</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Height / उंची (ft : inch)
                  </label>
                  <div className="d-flex heightDropdowns">
                    <Select
                      className="w-50 d-inline-block mr-1"
                      value={userInfo.exp_heightFt}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          exp_heightFt: event.target.value,
                        }));
                      }}
                    >
                      <MenuItem value="">Feet</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7</MenuItem>
                      <MenuItem value="8">8</MenuItem>
                    </Select>
                    <Select
                      className="w-50 d-inline-block ml-1"
                      value={userInfo.exp_heightInch}
                      onChange={(event) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          exp_heightInch: event.target.value,
                        }));
                      }}
                    >
                      <MenuItem value="">Inches</MenuItem>
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7</MenuItem>
                      <MenuItem value="8">8</MenuItem>
                      <MenuItem value="9">9</MenuItem>
                      <MenuItem value="10">10</MenuItem>
                      <MenuItem value="11">11</MenuItem>
                      <MenuItem value="12">12</MenuItem>
                    </Select>
                  </div>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <label className="inputFieldLabel w-100">Diet / आहार</label>
                <FormControl>
                  <RadioGroup
                    defaultValue="Both"
                    name="Diet"
                    row
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_diet: event.target.value,
                      }));
                    }}
                    value={userInfo.exp_diet}
                  >
                    <FormControlLabel
                      value="Veg"
                      control={<Radio />}
                      label="Veg"
                    />
                    <FormControlLabel
                      value="Non Veg"
                      control={<Radio />}
                      label="Non Veg"
                    />
                    <FormControlLabel
                      value="Both"
                      control={<Radio />}
                      label="Both"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-4">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Expected Education / अपेक्षित शिक्षण
                  </label>
                  <TextField
                    placeholder="Enter expected education"
                    size="small"
                    variant="outlined"
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_education: event.target.value,
                      }));
                    }}
                    value={userInfo.exp_education}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-3">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Maritial Status / वैवाहिक स्थिती
                  </label>
                  <Select
                    className="text-capitalize"
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_maritial_status: event.target.value,
                      }));
                    }}
                    value={userInfo.exp_maritial_status}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {maritial_statusValues.map((item, index) => {
                      return (
                        <MenuItem
                          value={item}
                          key={index}
                          className="text-capitalize"
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Max Age Difference / कमाल वय फरक
                  </label>
                  <TextField
                    type="number"
                    size="small"
                    variant="outlined"
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_age_diff: event.target.value,
                      }));
                    }}
                    value={userInfo.exp_age_diff}
                  />
                </FormControl>
              </div>
              <div className="mt-3 mb-3 col-sm-5">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Expected Occupation & Income per Annum / अपेक्षित व्यवसाय
                    आणि वार्षिक उत्पन्न
                  </label>
                  <textarea
                    placeholder="Enter Expected Occupation & Income per Annum"
                    className="p-2"
                    rows="6"
                    onChange={(event) => {
                      setUserInfo((prev) => ({
                        ...prev,
                        exp_occupation_income: event.target.value,
                      }));
                    }}
                    value={userInfo.exp_occupation_income}
                  ></textarea>
                </FormControl>
              </div>
              {/* <div className="mt-3 mb-3 col-sm-7">
                <div className="text-center">
                  <span className="captchaContainer">8787</span>
                </div>
                <div className="mt-3 mb-3 d-flex flex-col">
                  <label>
                    Please Enter Above Verification Code / कृपया वर सत्यापन कोड
                    प्रविष्ट करा
                  </label>
                  <div>
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="Enter the above code"
                    />
                  </div>
                </div>
              </div> */}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordianHeader"
          >
            <Typography className="textDarkRed">Acknowledge / ओळख</Typography>
          </AccordionSummary>
          <AccordionDetails className="accordianDetails font-bold font14px">
            {/* <div className="text-center">
                <label className="textDarkRed mb-3">
                  * Kindly bring cropping lines on photo at proper position and
                  then click on submit.{" "}
                  <span
                    className="link hyperLink"
                    onClick={() => {
                      handleClickOpen();
                    }}
                  >
                    Click here
                  </span>{" "}
                  to see the guidelines for uploading photos.
                </label>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="photoText">
                    <label className="textDarkRed d-block">
                      1) Upload your first profile picture (Close-up view
                      preferred) :
                    </label>
                    <label className="textDarkRed d-block pl-3">
                      तुमचे पहिले प्रोफाइल चित्र अपलोड करा (क्लोज-अप प्राधान्य):
                    </label>
                  </div>
                </div>
                <div className="col-md-5">
                  <input
                    type="file"
                    name="image1_id"
                    accept="image/*"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      if (file && file.size > 50 * 1024 * 1024) {
                        alert(
                          "File size exceeds 50 MB limit. Please upload a smaller file."
                        );
                        return;
                      }
                      setFiles((prev) => ({
                        ...prev,
                        image1_id: file,
                      }));
                    }}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="photoText">
                    <label className="textDarkRed d-block">
                      2) Upload your second profile picture, if intrested :
                    </label>
                    <label className="textDarkRed d-block pl-3">
                      तुमचे दुसरे प्रोफाइल चित्र अपलोड करा :
                    </label>
                  </div>
                </div>
                <div className="col-md-5">
                  <input
                    type="file"
                    name="image2_id"
                    accept="image/*"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      if (file && file.size > 50 * 1024 * 1024) {
                        alert(
                          "File size exceeds 50 MB limit. Please upload a smaller file."
                        );
                        return;
                      }
                      setFiles((prev) => ({
                        ...prev,
                        image2_id: file,
                      }));
                    }}
                    required
                  />
                </div>
              </div>
              <div>
                <label className="textDarkRed">
                  You can also submit your photos after getting registration
                  number through photo edit option.
                </label>
              </div> */}
            <div className="row">
              <div className="mt-3 mb-3 col-sm-2">
                <FormControl variant="outlined" className="w-100" size="small">
                  <label className="inputFieldLabel">
                    Committee Member / समिती सदस्य *
                  </label>
                  <div className="d-flex heightDropdowns">
                    <Select
                      error={
                        submitBtnClicked && userInfo.committee_member === ""
                      }
                      className="w-100 d-block mr-1 text-capitalize"
                      value={userInfo.committee_member}
                      onChange={(event) => {
                        console.log(
                          "event.target.value.................",
                          event.target.value
                        );
                        setUserInfo((prev) => ({
                          ...prev,
                          committee_member: event.target.value,
                        }));
                      }}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {committeeMembers?.map((item, index) => {
                        return (
                          <MenuItem
                            value={item}
                            key={index}
                            className="text-capitalize"
                          >
                            {item}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  {submitBtnClicked && userInfo.committee_member === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
            </div>
            <div className="textDarkRed">
              <Checkbox
                onChange={(event) => {
                  setUserInfo((prev) => ({
                    ...prev,
                    acknowledgement:
                      event.target.checked === true ? "Yes" : "No",
                  }));
                }}
              />
              <span>
                I have read and accepted all the{" "}
                <span
                  onClick={() => {
                    navigate("/terms");
                  }}
                  className="link hyperLink"
                >
                  Terms and Conditions.
                </span>
              </span>
            </div>
            <Dialog
              onClose={handleClose}
              open={open}
              className="picSpecifications"
            >
              <section>
                <div className="row">
                  <div className="col accordianDetails p-3">
                    <div className="row">
                      <div className="col phoneFullWIdth">
                        <div className="d-inline-block w-50">
                          <label className="textDarkRed d-block">
                            Photo Close Up
                          </label>
                          <img src={picGuildLines} alt="" />
                        </div>
                        <div className="d-inline-block w-50">
                          <label className="textDarkRed d-block">
                            Photo Full View
                          </label>
                          <img src={picGuildLines} alt="" />
                        </div>
                      </div>
                      <div className="col phoneFullWIdth">
                        <div className="d-inline-block">
                          <label className="textDarkRed d-block">
                            Photo Guidelines
                          </label>
                          <img src={picGuildLines} alt="" />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="textDarkRed font22px">Know More</label>
                      <div className="row">
                        <div className="col phoneFullWIdth">
                          <label className="textDarkRed font18px">Do's</label>
                          <ul className="pl-3">
                            <li>
                              Your Photo should be front facing and your entire
                              face should be visible.
                            </li>
                            <li>
                              Ensure that your Photo is recent and not with a
                              group.
                            </li>
                            <li>
                              You can upload upto 2 Photos to your Profile.
                            </li>
                            <li>
                              Each Photo must be less than 15 MB in size and
                              must be in one of the following formats jpg, png
                            </li>
                          </ul>
                        </div>
                        <div className="col phoneFullWIdth">
                          <label className="textDarkRed font18px">Dont's</label>
                          <ul className="pl-3">
                            <li>
                              Watermarked, digitally enhanced, morphed Photos or
                              Photos with your personal information will be
                              rejected.
                            </li>
                            <li>
                              Irrelevant Photographs will lead to deactivation
                              of your Profile and Membership.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Dialog>
          </AccordionDetails>
        </Accordion>
        <div className="submitSection text-center">
          <label className="textDarkRed font-bold font22px d-block">
            - Important Information -
          </label>
          <span className="d-block">
            We are sending out official payment link viw email id{" "}
            <b>kumbharmangalam.com</b> or contact <b>9272183132</b>
          </span>
          <Button
            type="submit"
            disabled={userInfo.acknowledgement === "Yes" ? false : true}
            //disabled={true}
            size="large"
            variant="contained"
            className={
              userInfo.acknowledgement === "Yes"
                ? "buttonClass"
                : "disabledBtn buttonClass"
            }
            onClick={() => {
              setSubmitBtnClicked(true);
              submitUserDetails();
            }}
          >
            Submit
          </Button>
          {(userInfo.first_name === "" ||
            userInfo.middle_name === "" ||
            userInfo.last_name === "" ||
            userInfo.dob === "" ||
            userInfo.adhar === "" ||
            userInfo.mobile_no === "" ||
            userInfo.email === "" ||
            userInfo.committee_member === "" ||
            userInfo.birth_time === "") &&
            submitBtnClicked && (
              <div className="requiredText mt-2">
                {" "}
                Please fill the required fields
              </div>
            )}
        </div>
        {/* </form> */}
      </section>
      <FooterComponent />
    </>
  );
};
export default Registration;
